import http from "../config/axios";

interface createNotificationProps {
    title: string;
    body: string;
}

export async function createNotification ({ title, body }: createNotificationProps ) {
    const url = `/notify/all`;
    try {
        const response = await http.request({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url,
            data: {
                title,
                body,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao criar bairro:", error);
        throw error;
    }
}


export async function listNotification(limit = 10, offset = 0) {
    try {
        const response = await http.request({
            method: "GET",
            url: "/notify/list",
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações dos bairros:", error);
        throw error;
    }
}